import React from 'react';
import styled from 'styled-components';
import { observer } from "mobx-react-lite";
import { useTranslation } from 'react-i18next';
import { translationStore } from '../../stores/TranslationStore';
import { Overlay, CenterContainer, PopupWindow } from '../shared/PopupComponents';
import { UiConstants } from '../../data/UiConstants';
import { LoadingBarBlock } from '../shared/LoadingBar';
const ModalOverlay = styled(Overlay).withConfig({
  displayName: "TranslationImporting__ModalOverlay",
  componentId: "sc-in68ts-0"
})(["z-index:", ";"], UiConstants.Z_INDEX_MODAL);
const ErrorDiv = styled.div.withConfig({
  displayName: "TranslationImporting__ErrorDiv",
  componentId: "sc-in68ts-1"
})(["color:darkred;"]);
export const TranslationImportingPopup = observer(() => {
  const {
    t
  } = useTranslation();
  if (!translationStore.showingImportingPopup) return null;
  const {
    isImporting,
    importResults
  } = translationStore;
  const {
    progressPercentage100Floored,
    successfulLines,
    failedLines,
    totalLineCount
  } = importResults;
  return /*#__PURE__*/React.createElement(ModalOverlay, null, /*#__PURE__*/React.createElement(CenterContainer, null, /*#__PURE__*/React.createElement(PopupWindow, null, /*#__PURE__*/React.createElement("h1", null, t("translation.importing_popup_headline", {
    totalLineCount
  })), /*#__PURE__*/React.createElement(LoadingBarBlock, {
    label: t("translation.import_progress"),
    percentage100: progressPercentage100Floored
  }), failedLines > 0 && /*#__PURE__*/React.createElement(ErrorDiv, null, t("translation.import_lines_failed", {
    failedLines
  })), !isImporting && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, t("translation.importing_finished")), /*#__PURE__*/React.createElement("div", null, t("translation.importing_finished_successful_line_count", {
    successfulLines
  })), failedLines > 0 && /*#__PURE__*/React.createElement(ErrorDiv, null, t("translation.importing_finished_failed_line_count", {
    failedLines
  }))), /*#__PURE__*/React.createElement("button", {
    disabled: isImporting,
    onClick: translationStore.closeImportingPopup
  }, t("translation.importing_popup_close")))));
});